<template>
  <div class="page-container">
    <!--内容-->
    <div class="container pt-200">
      <!--面包屑导航-->
      <Breadcrumb :breadcrumbList="[detailname]"></Breadcrumb>
      <div class="noticecon pb-50">
        <div class="tip bg-colfa flex ai-center">
          <span class="fontcol4 fs-24 ml-35">{{ detailname }}</span>
          <span class="fontcol6 fs-28 fstyle-italic">{{
            type == 1 ? "/News" : "/Announcement"
          }}</span>
        </div>
        <div class="notice">
          <div class="noticebanner mt-40">
            <img
              v-if="swiperlist.length == 1"
              :src="server+swiperlist[0].cover"
              alt=""
            />
            <!--轮播图-->
            <Slider
              class="noticebanner mt-40"
              :bannerphoto="swiperlist"
              v-else
              :type="3"
            ></Slider>
          </div>
          <div class="line mt-40 mb-m0"></div>
          <div class="noticelist pt-20">
            <li
              class="point"
              v-for="(item, index) in noticelist"
              :key="index"
              @mouseenter="mousenotice(index)"
              @click="chosenotice(index)"
            >
              <ListModel
                :listdate="item"
                :index="index"
                type="1"
                :noticeindex="noticeid"
              ></ListModel>
            </li>
            <!--分页-->
            <div class="pagination mt-50 pb-10 flex jc-center ai-center">
              <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                layout="prev, pager, next, jumper"
                :page-size="Number(5)"
                :total="total"
                hide-on-single-page
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../components/common/breadcrumb";
import Slider from "../components/common/swiper";
import ListModel from "../components/common/newmodel";
export default {
  name: "noticelist",
  components: {
    Slider,
    Breadcrumb,
    ListModel,
  },
  data() {
    return {
      type:1,//类型1-新闻2-公告
      server:'http://www.cctpress.com/file/',
      detailname: "新闻",
      noticeid: 0, //新闻所选的id
      total:0,//列表总页数
      swiperlist: [],//轮播图列表
      noticelist: [], //人才招聘列表
      currentPage: 1, //默认当前页为第一页
    };
  },
  mounted() {
    if(this.$route.query.type){
        this.type = this.$route.query.type;
    }
    if (this.type == 1) {
      this.detailname = "新闻";
    } else {
      this.detailname = "公告";
    }
    this.getlist();
    this.getswiper();
  },
  methods: {
    //获取轮播图列表
     async getswiper() {
      var params = {};
      if (this.type == 1) {
        params = {
          type: this.CONSTANT.getDateByCode("banner_news").id
        };
      }else{
         params = {
           type: this.CONSTANT.getDateByCode("banner_notice").id
        };
      }

      var res = await this.$API.API_Ajax("轮播图接口", params);
      if (res.code == 200) {
        this.swiperlist = res.data;
      }
    },
    //查询新闻列表
    async getlist() {
      var params = {};
      if (this.type == 1) {
        params = {
          columnId: this.CONSTANT.getDateByCode("news_id").id,
          pageNum: this.currentPage,
          pageSize: "5",
        };
      }else{
         params = {
          columnId: this.CONSTANT.getDateByCode("notice_id").id,
          pageNum: this.currentPage,
          pageSize: "5",
        };
      }

      var res = await this.$API.API_Ajax("新闻公告动态", params);
      if (res.code == 200) {
        var list=res.data.list;
        list.map(item=>{
          item.month=this.$moment(new Date(item.createTime.time).getTime()).format('MM')
          item.day=this.$moment(new Date(item.createTime.time).getTime()).format('DD')
        })
        this.noticelist = list;
        this.total=Number(res.data.total);
        //查询成功后回到顶部
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    },
    //公告选中状态
    mousenotice(index) {
      this.noticeid = index;
    },
    //公告选中跳转
    chosenotice(index) {
      this.noticeid = index;
    },
    handleCurrentChange(currentPage) {
      this.currentPage=currentPage;
      this.getlist()
    },
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  width: 100%;
  height: auto;
  margin: auto;
  .noticecon {
    width: 65%;
    margin: auto;
    margin-top: 80px;
    margin-bottom: 100px;
    border: 1px solid #e8e8e8;
    .tip {
      width: 100%;
      height: 70px;
      border: 1px solid #ededed;
    }
    .notice {
      width: 1170px;
      margin: auto;
      .noticebanner {
        width: 100%;
        height: 245px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .line {
        width: 1210px;
        height: 1px;
        background: #ededed;
        margin-left: -20px;
      }
      .noticelist {
        width: 100%;
        margin: auto;
        .pagination {
          .btn {
            width: 60px;
            height: 24px;
          }
        }
      }
    }
  }
}
</style>
